import { NgModule } from '@angular/core';
import { FormComponentComponent } from './form-component/form-component.component';
import { AngularMaterialModule } from '../angularMaterial.module';


@NgModule({
  declarations: [
    FormComponentComponent
  ],
  imports: [
    AngularMaterialModule
  ],
  exports: [
    FormComponentComponent
  ]
})
export class SharedModule { }
